<roma-modal-template
  [size]="'sm'"
  [contentMinHeight]="true"
  [headerBottomMargin]="'4px'"
  (cancel)="exit()"
  [showDefaultButtons]="false"
  class="charge-deal-modal"
  [title]="'chargeDealModal.title' | translate"
>
  <div class="charge-deal-modal-body">
    <span class="charge-deal-modal-text">{{
      'chargeDealModal.body' | translate
    }}</span>
    <div class="charge-deal-modal-footer">
      <button (click)="onInvoice()" class="charge-deal-modal-button">
        <icon-svg
          type="linear/file-dollar-alt"
          size="20"
          strokeColor="#3C48EC"
          fillColor="none"
        ></icon-svg>
        {{ 'chargeDealModal.invoice' | translate }}
      </button>
      <button (click)="onSimplified()" class="charge-deal-modal-button">
        <icon-svg
          type="linear/sales-tickets"
          size="20"
          strokeColor="#3C48EC"
          fillColor="none"
        ></icon-svg>
        {{ 'chargeDealModal.simplifiedInvoice' | translate }}
      </button>
    </div>
  </div>
</roma-modal-template>
